export type OS = 'android' | 'ios' | 'macos_m' | 'macos_intel' | 'windows' | 'linux' | 'unknown';

export function useOS() {

	const get = async (): Promise<OS> => {
		const userAgent = navigator.userAgent.toLowerCase();

		// 📌 Проверка мобильных платформ
		if (userAgent.includes("android")) return "android";
		if (/iphone|ipad|ipod/.test(userAgent)) return "ios";

		// 📌 Проверка Windows
		if (userAgent.includes("win")) return "windows";

		// 📌 Проверка Linux
		if (userAgent.includes("linux") && !userAgent.includes("android")) return "linux";

		// 📌 Проверка macOS
		if (userAgent.includes("mac")) {
			const isLittleEndian = new Uint8Array(new Uint32Array([1]).buffer)[0] === 1;
			if (isLittleEndian) {
				return "macos_m"; // Apple Silicon
			} else {
				return "macos_intel"; // Intel Mac
			}
		}

		return "unknown";
	}


	return {
		get
	};
}
